import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from './ui/dialog';
import { Button } from './ui/button';
import { useAuth } from '../contexts/AuthContext';
import api from '../config/api';
import DepartmentField from './DepartmentField';

/* Asks once per visit — anyone at Acuity without a department (not on the HR
   employee sheet and none picked in Profile). "Later" waits until the next
   time they open AcuityFlo. Guests are never asked. */
const DepartmentPrompt = () => {
  const { user } = useAuth();
  const [state, setState] = useState(null);
  const key = user ? `aflo_dept_asked_${user.id}` : '';

  useEffect(() => {
    if (!user) return undefined;
    try { if (sessionStorage.getItem(key)) return undefined; } catch (_) { /* private mode */ }
    let gone = false;
    api.get('/auth/me/department')
      .then((r) => {
        if (gone) return;
        if (r.data?.required) setState(r.data);
        else try { sessionStorage.setItem(key, '1'); } catch (_) { /* fine */ }
      })
      .catch(() => {});
    return () => { gone = true; };
  }, [user?.id]); // eslint-disable-line react-hooks/exhaustive-deps

  const close = () => {
    try { sessionStorage.setItem(key, '1'); } catch (_) { /* fine */ }
    setState(null);
  };
  if (!state) return null;

  return (
    <Dialog open onOpenChange={(open) => { if (!open) close(); }}>
      <DialogContent className="sm:max-w-md" data-testid="department-prompt">
        <DialogHeader>
          <DialogTitle>Which department are you in?</DialogTitle>
          <DialogDescription>
            Pick it from the list, or type it if it isn’t there. You can change it later in Settings → General.
          </DialogDescription>
        </DialogHeader>
        <DepartmentField state={state} onSaved={close} autoFocus />
        <div className="flex justify-end">
          <Button variant="ghost" size="sm" onClick={close} data-testid="department-later">Later</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default DepartmentPrompt;
